import { createContext, type ReactNode, useContext, useState } from "react";

interface SelectionContextType {
  selectedRows: { id: string }[];
  setSelectedRows: (rows: { id: string }[]) => void;
  clearSelection: () => void;
}

const SelectionContext = createContext<SelectionContextType | undefined>(
  undefined,
);

export function SelectionProvider({ children }: { children: ReactNode }) {
  const [selectedRows, setSelectedRows] = useState<{ id: string }[]>([]);
  const clearSelection = () => setSelectedRows([]);

  return (
    <SelectionContext.Provider
      value={{ selectedRows, setSelectedRows, clearSelection }}
    >
      {children}
    </SelectionContext.Provider>
  );
}

export function useSelection() {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error("useSelection must be used within SelectionProvider");
  }
  return context;
}
